<template>
    <div class="bindBox">
        <i class="el-icon-loading" v-if="isLoading"></i>
        <el-result icon="success" v-if="resultType==1"></el-result>
        <el-result icon="warning" v-if="resultType==2"></el-result>
        <div class="text-current">
            {{textCurrent}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true,
            textCurrent: "绑定中...",
            resultType: 0,
        };
    },
    methods: {
        onBind(){
            let instanceKey = this.$route.query.instanceKey;
            if(!instanceKey){
                return this.$message.error("参数错误");
            }
            this.$axios.get(`${this.$customerUrl}/WhatsApp/Bind?instanceKey=${instanceKey}`).then((res) => {
                const {isSuccess, data} = res;
                this.isLoading = false;
                if(isSuccess && data) {
                    this.resultType = 1;
                    this.textCurrent = "绑定成功";
                    setTimeout(()=>{
                        window.parent.postMessage({ action: 'closeIframe' },'*');
                    }, 1000);
                }else{
                    this.resultType = 2;
                    this.textCurrent = "绑定失败";
                }
            });
        },
    },
    mounted() {
        this.onBind();
    },
};
</script>

<style lang='scss' scoped>
.bindBox{
    text-align: center;
    padding-top: 100px;
    color: #3a3a3a;
    .el-icon-loading{
        font-size: 150px;
    }
    .text-current{
        font-size: 28px;
    }
}
</style>